import IAction from '../../models/IAction';
import EntitlementListModel, { UserEntitlementListModel } from '../models/EntitlementModel';
import EntitlementActions from '../actions/entitlementActions';
import { Reducer } from 'redux';
import baseReducer from '../../utilities/BaseReducer';

export interface IEntitlementState {
  entitlementList: EntitlementListModel[];
  updated: boolean;
  deletedAllEntitlement: boolean;
  deleteEntitlement: EntitlementListModel;
  createdEntitlement: EntitlementListModel;
  createdEntitlementList: string;
  entitlementListLoggedUser: UserEntitlementListModel[];
}
const initialState = {
  entitlementList: [],
  updated: false,
  deletedAllEntitlement: false,
  deleteEntitlement: new EntitlementListModel({}),
  createdEntitlement: new EntitlementListModel({}),
  createdEntitlementList: '',
  entitlementListLoggedUser: [],
};

export const entitlementReducer:Reducer = baseReducer(initialState, {
  [EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST_FINISHED]: (state: IEntitlementState, action: IAction<EntitlementListModel[]>):IEntitlementState => {
    return { 
      ...state,
      entitlementList: action.payload!
    };
  },
  [EntitlementActions.REQUEST_UPDATE_ENTITLEMENT_FINISHED]: (state: IEntitlementState, action: IAction<EntitlementListModel>):IEntitlementState => {
    return { 
      ...state,
      updated: true
    };
  },
  [EntitlementActions.REQUEST_DELETE_ALL_ENTITLEMENT_OF_USER_FINISHED]: (state: IEntitlementState, action: IAction<EntitlementListModel>):IEntitlementState => {
    return { 
      ...state,
      deletedAllEntitlement: true
    };
  },
  [EntitlementActions.REQUEST_DELETE_ENTITLEMENT_FINISHED]: (state: IEntitlementState, action: IAction<EntitlementListModel>):IEntitlementState => {
    return { 
      ...state,
      deleteEntitlement: action.payload!
    };
  },
  [EntitlementActions.REQUEST_POST_ENTITLEMENT_FINISHED]: (state: IEntitlementState, action: IAction<EntitlementListModel>):IEntitlementState => {
    return { 
      ...state,
      createdEntitlement: action.payload!
    };
  },
  [EntitlementActions.REQUEST_POST_ENTITLEMENT_LIST_FINISHED]: (state: IEntitlementState, action: IAction<string>):IEntitlementState => {
    return { 
      ...state,
      createdEntitlementList: action.payload!
    };
  },
  [EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST_LOGGED_USER_FINISHED]: (state: IEntitlementState, action: IAction<UserEntitlementListModel[]>):IEntitlementState => {
    return { 
      ...state,
      entitlementListLoggedUser: action.payload!
    };
  },
});

